import { ContentService } from "../../../services/content.service.js";

/**
 * 5-Star Rating Component for Viewers
 * Rating Component with True Optimistic UI and Interaction Lock
 */
export const RatingComponent = async (container, {
    seriesId,
    episodeId, // [FIX] New Prop
    initialRating = 0,
    initialCount = 0
}) => {
    // State
    let myRating = 0;
    let average = initialRating;
    let count = initialCount;
    let hasInteracted = false; // [FIX] Lock

    // Helper: Update Visuals only
    const updateStarsVisual = (value, isHover) => {
        const stars = container.querySelectorAll('.star-btn span');
        stars.forEach((icon, idx) => {
            const starVal = idx + 1;
            if (starVal <= value) {
                icon.classList.remove('text-zinc-600');
                icon.classList.add('text-yellow-400');
                icon.style.fontVariationSettings = "'FILL' 1";
            } else {
                icon.classList.add('text-zinc-600');
                icon.classList.remove('text-yellow-400');
                icon.style.fontVariationSettings = "'FILL' 0";
            }
        });
    };

    // Helper: Bind Events
    const bindEvents = () => {
        const stars = container.querySelectorAll('.star-btn');
        const starContainer = container.querySelector('#star-container');

        // Hover Effects
        stars.forEach(btn => {
            btn.onmouseenter = () => {
                const val = parseInt(btn.dataset.value);
                updateStarsVisual(val, true);
            };
        });

        if (starContainer) {
            starContainer.onmouseleave = () => {
                updateStarsVisual(myRating || Math.round(average), false);
            };
        }

        stars.forEach(btn => {
            btn.onclick = async () => {
                if (!window.user) {
                    if (await window.Modal.confirm("로그인이 필요한 서비스입니다.\n로그인 페이지로 이동하시겠습니까?", "로그인 필요")) {
                        window.router.navigate('/login');
                    }
                    return;
                }

                const rating = parseInt(btn.dataset.value);

                // Optimistic UI
                const oldRating = myRating;
                myRating = rating;
                hasInteracted = true; // [FIX] Lock interaction
                render(); // Re-render

                try {
                    // [Security] Block rating in Preview/Mock mode
                    if (!seriesId || seriesId === 'undefined') {
                        console.error("Missing ID:", { seriesId, episodeId });
                        window.Modal.alert("시스템 오류: 시리즈 정보를 찾을 수 없습니다.");
                        return;
                    }

                    if (String(seriesId).startsWith('preview')) {
                        window.Modal.toast("미리보기 모드에서는 평가가 저장되지 않습니다.");
                        return;
                    }

                    // [Secure] Call rateEpisode (Hierarchical)
                    await ContentService.rateEpisode(window.user.uid, seriesId, episodeId, rating);

                    // Update stats locally (simplified)
                    if (oldRating === 0) count++;

                    window.Modal.toast("평가가 반영되었습니다!");
                } catch (e) {
                    console.error(e);
                    myRating = oldRating; // Revert
                    render();
                    window.Modal.alert("평가 저장 실패: " + e.message);
                }
            };
        });
    };

    // Main Render
    function render() {
        container.innerHTML = `
            <div class="flex flex-col items-center justify-center p-6 bg-zinc-900/50 backdrop-blur-sm rounded-xl border border-zinc-800 mx-4 my-8 max-w-md mx-auto relative group">
                <h3 class="text-zinc-400 text-xs font-bold uppercase tracking-wider mb-3">이 작품 평가하기</h3>
                
                <div class="flex items-center gap-1 mb-2" id="star-container">
                    ${[1, 2, 3, 4, 5].map(star => `
                        <button class="star-btn p-1 transition-transform hover:scale-110 focus:outline-none" data-value="${star}">
                            <span class="material-symbols-outlined text-3xl transition-colors ${star <= (myRating || Math.round(average)) ? 'text-yellow-400' : 'text-zinc-600'}"
                                  style="font-variation-settings: 'FILL' ${star <= (myRating || Math.round(average)) ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 48;">
                                star
                            </span>
                        </button>
                    `).join('')}
                </div>

                <div class="flex items-center gap-2 text-zinc-500 text-xs">
                    <span class="font-bold text-yellow-400 text-lg">${average.toFixed(1)}</span>
                    <span>/ 5.0</span>
                    <span class="text-zinc-600">(${count.toLocaleString()}명 참여)</span>
                </div>

                ${myRating > 0 ? `<div class="mt-2 text-xs text-indigo-400 font-bold animate-fade-in">참여 완료!</div>` : ''}
                
                ${!window.user ? `<div class="absolute inset-0 z-10" id="login-blocker"></div>` : ''}
            </div>
        `;

        bindEvents();
    };

    // Initial Render
    render();

    // Async Fetch User Rating
    if (window.user) {
        ContentService.getUserRating(window.user.uid, seriesId, episodeId)
            .then(rating => {
                // [FIX] Interaction Lock
                if (!hasInteracted) {
                    myRating = rating;
                    render();
                }
            })
            .catch(console.error);
    }
};
